<template>
	<v-container class="register-page">
		<v-row>
			<v-col md="4" offset-md="4" :class="{ 'margin-bottom': $vuetify.breakpoint.mdAndUp }">
				<h1 class="text-center register-page__title mb-4">Sign Up</h1>
				<div v-if="!successMessage">
					<RegisterForm @success="showSuccessMessage" />
				</div>
				<div v-else>
					<p class="text--black text-center register-page__success-message mb-12">
						Thank you for registering. A message has been sent to your email address to
						activate your account
					</p>
					<div class="d-flex justify-center align-center">
						<a class="text-left register-page__link" @click="navigateToLoginPage"
							>Login</a
						>
						<span class="mr-1 ml-1">or</span>
						<a
							class="text-right register-page__link"
							@click="successMessage = !successMessage"
							>Register a new Account</a
						>
					</div>
				</div>
				<a class="center terms mt-10 d-flex justify-center" @click="navigateToTermsPage"
					>Terms & Privacy</a
				>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import RegisterForm from '@/components/Forms/RegisterForm'

export default {
	name: 'RegisterPage',
	components: {
		RegisterForm,
	},
	data: () => ({
		successMessage: false,
	}),
	methods: {
		navigateToLoginPage() {
			this.$router.push({ name: 'login' })
		},
		showSuccessMessage() {
			this.successMessage = true
		},
		navigateToTermsPage() {
			this.$router.push({ name: 'terms-and-privacy' })
		},
	},
}
</script>

<style lang="scss">
.register-page {
	&__title {
		font-family: Merriweather;
		font-size: 38px;
		font-weight: 700;
	}

	&__success-message {
		font-family: Montserrat;
		font-style: normal;
		font-weight: 500;
		font-size: 16px;
		text-align: center;
	}

	&__link {
		font-style: normal;
		font-weight: 700;
		font-size: 15px;
		color: #db7842 !important;

		span {
			font-style: normal;
			font-family: Montserrat;
			font-size: 15px;
		}
	}

	.margin-bottom {
		margin-bottom: 166px;
	}
}

.terms {
	color: #d9e0d6 !important;
	font-weight: 400;
}
</style>
